module.exports = __webpack_public_path__ + "assets/img/logoLeftIcon.0fee3932.png";